"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var scrollConditions = {
  up: {
    scrollStepPx: 20,
    stopCondition: function stopCondition(currentOffset, targetOffset) {
      return currentOffset <= targetOffset;
    }
  },
  down: {
    scrollStepPx: -20,
    stopCondition: function stopCondition(currentOffset, targetOffset) {
      return targetOffset - currentOffset <= 0;
    }
  }
};

var animateScroll = function animateScrollHelper(targetOffset) {
  var currentOffset = window.pageYOffset;
  var _int = null;
  var scrollSpeed = 5;
  var scrollDirection;

  if (currentOffset > targetOffset) {
    scrollDirection = 'up';
  }

  if (currentOffset < targetOffset) {
    scrollDirection = 'down';
  }

  if (currentOffset === targetOffset) {
    return;
  }

  var _scrollConditions$scr = scrollConditions[scrollDirection],
      scrollStepPx = _scrollConditions$scr.scrollStepPx,
      stopCondition = _scrollConditions$scr.stopCondition;
  _int = setInterval(function () {
    currentOffset -= scrollStepPx;
    window.scrollTo(0, currentOffset);

    if (stopCondition(currentOffset, targetOffset)) {
      clearInterval(_int);
    }
  }, scrollSpeed);
};

var _default = animateScroll;
exports["default"] = _default;